<template>
  <section class="corpusDetail-section" v-loading="loading">
    <header class="corpusDetail-section-header" :class="getStatusClass">
      <div class="top-warp">
        <div class="left">
          <img src="../images/icon-corpus-title.png" alt="">
          <el-tooltip effect="dark" :disabled="tipsDisabled" :content="corpusDetailInfo.name" placement="top-start">
            <div class="corpus-name" @mouseover="mouseOverShowTips($event)" v-if="fromType == 'corpus'">
              {{ corpusDetailInfo.name ? corpusDetailInfo.name : '--' }}
            </div>
            <div class="corpus-name" @mouseover="mouseOverShowTips($event)" v-if="fromType == 'warehousing'">
              {{ bankInfo.name ? bankInfo.name : '--' }}
            </div>
          </el-tooltip>
          <el-tooltip v-if="corpusDetailInfo.langDesc" effect="dark" :disabled="tipsDisabled"
            :content="$i18n.locale === 'zh' ? corpusDetailInfo.langDesc.replace('>', ' — ') : getEnlang(corpusDetailInfo.sourceLang, corpusDetailInfo.targetLang)"
            placement="top-start">
            <div class="corpus-langDesc" @mouseover="mouseOverShowTips($event)">
              {{ $i18n.locale === 'zh' ? corpusDetailInfo.langDesc.replace('>', ' - ') :
                getEnlang(corpusDetailInfo.sourceLang, corpusDetailInfo.targetLang) }}
            </div>
          </el-tooltip>
          <div class="corpus-domain" v-show="corpusDetailInfo.domainName">
            {{ $i18n.locale === 'zh' ? corpusDetailInfo.domainName : getEnDomain(corpusDetailInfo.domainCode) }}
          </div>
        </div>
        <div class="right">
          <!-- 
            已入库： 2
            审核中：取消 1
            已退回：编辑、重新入库、删除 3
            已取消：编辑、重新入库、删除 4
          -->
          <!-- 编辑 -->
          <el-button size="small" class="right-btn editor" @click="editorBankVisible = true"
            v-if="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus'">
            <i class="btn-icon editor-btn"></i>
            <span>{{ $t('common.edit') }}</span>
          </el-button>
          <!-- 下载 -->
          <el-button size="small" class="right-btn download" @click="downloadBankVisible = true"
            v-if="fromType === 'corpus'">
            <i class="btn-icon download-btn"></i>
            <span>{{ $t('common.download') }}</span>
          </el-button>
          <!-- 入库 -->
          <el-button size="small" class="right-btn warehousing" @click="handleRuku" v-if="fromType === 'corpus'">
            <i class="btn-icon warehousing-btn"></i>
            <span>{{ $t('memoryBankV2.Warehousing') }}</span>
          </el-button>
          <!-- 重新入库 -->
          <el-button size="small" class="right-btn warehousing" @click="handleRuku"
            v-if="fromType === 'warehousing' && bankStatus == 3 || bankStatus == 4">
            <i class="btn-icon warehousing-btn"></i>
            <span>{{ $t('warehousingAudit.restorage') }}</span>
          </el-button>
          <!-- 删除 -->
          <el-button size="small" class="right-btn delete" @click="deleteBankVisible = true"
            v-if="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus'">
            <i class="btn-icon delete-btn"></i>
            <span>{{ $t('common.del') }}</span>
          </el-button>
          <!-- 取消入库 -->
          <el-button size="small" class="right-btn cancle" @click="handleCancelBanke"
            v-if="fromType === 'warehousing' && bankStatus == 1">
            <i class="btn-icon cancle-btn"></i>
            <span>{{ $t('warehousingAudit.cancelBanke') }}</span>
          </el-button>
        </div>
      </div>
      <div class="bottom-warp" v-if="fromType == 'corpus'">
        <div class="top">
          <div class="top-item corpus-sentCount">
            <span class="label">{{ $t('memoryBankV2.sentenceNum') }}：</span>{{ corpusDetailInfo.sentCount ?
              corpusDetailInfo.sentCount : 0 }}
          </div>
          <!-- <div class="top-item corpus-inStockCount">
            <span class="label">{{ $t('warehousingAudit.warehousinSentCount') }}：</span>{{ corpusDetailInfo.inStockCount ?
              corpusDetailInfo.inStockCount : 0 }}
          </div> -->
          <div class="top-item corpus-create-time">
            <span class="label">{{ $t('memoryBankV2.createTime') }}：</span>{{ corpusDetailInfo.createTime ?
              corpusDetailInfo.createTime : '--' }}
          </div>
        </div>
        <div class="corpus-remark">
          <span class="label">{{ $t('memoryBankV2.remark') }}：</span>{{ corpusDetailInfo.remark ? corpusDetailInfo.remark
            : '--' }}
        </div>
      </div>
      <!-- 审核记录进入 -->
      <div class="bottom-warp" v-else-if="fromType == 'warehousing'">
        <div class="top">
          <!-- 句对数 -->
          <div class="top-item corpus-sentCount">
            <span class="label">{{ $t('memoryBankV2.sentenceNum') }}：</span>{{ bankInfo.sentCount ?
              bankInfo.sentCount : 0 }}
          </div>
          <!-- 提交时间 -->
          <div class="top-item corpus-inStockCount">
            <span class="label">{{ $t('warehousingAudit.submissionTime') }}：</span>{{ bankInfo.createTime ?
              bankInfo.createTime : 0 }}
          </div>
          <!-- 审核时间 -->
          <div class="top-item corpus-create-time">
            <span class="label">{{ $t('warehousingAudit.reviewTime') }}：</span>{{ bankInfo.reviewTime ?
              bankInfo.reviewTime : '--' }}
          </div>
          <!-- 审核人 -->
          <div class="top-item corpus-create-time">
            <span class="label">{{ $t('warehousingAudit.auditor') }}：</span>{{ bankInfo.reviewerName ?
              bankInfo.reviewerName : '--' }}
          </div>
          <!-- 评分 -->
          <div class="top-item corpus-create-time" v-if="bankStatus == 2 ">
            <span class="label">{{ $t('warehousingAudit.score') }}：</span>{{ bankInfo.scoreStatus ?
              bankInfo.score : '未评分' }}
          </div>
        </div>
        <!-- 备注 -->
        <div class="corpus-remark">
          <span class="label">{{ $t('memoryBankV2.remark') }}：</span>{{ corpusDetailInfo.remark ? corpusDetailInfo.remark
            : '--' }}
        </div>
        <!-- 评价 -->
        <div class="corpus-remark" v-if="bankStatus == 2">
          <span class="label">{{ $t('warehousingAudit.evaluate') }}：</span>{{ bankInfo.evaluate ? bankInfo.evaluate
            : '--' }}
        </div>
      </div>
    </header>
    <main
      :class="{ 'corpusDetail-section-container': true, 'corpusDetail-section-container-tuihui': fromType === 'warehousing' && bankStatus == 3 }">
      <div class="table-operation">
        <div class="left">
          <el-button :disabled="isAddStatus" size="small" class="left-btn import-btn" @click="handleImport"
            v-if="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus'">
            {{ $t('common.import') }}
          </el-button>
          <el-button :disabled="isAddStatus" size="small" class="left-btn addSent-btn" @click="handleAddSent"
            v-if="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus'">
            {{ $t('common.addASingleSentence') }}
          </el-button>
        </div>
        <div class="right">
            <!-- 修改痕迹按钮 -->
            <div class="modification">
              <div class="text">修改痕迹</div>
              <el-switch
                v-model="editorMode"
                :active-value="'mark'"
                :inactive-value="'standard'"
                >
              </el-switch>
            </div>
            <el-select v-show="editorMode == 'mark'&& bankStatus == 2 || editorMode == 'mark' && bankStatus == 3" v-model="viewType" placeholder="请选择" size="small">
            <el-option
              :key="'student'"
              :label="'我自己'"
              :value="'student'">
            </el-option>
            <el-option
              :key="'teacher'"
              :label="'老师'"
              :value="'teacher'">
            </el-option>
          </el-select>
          <el-input class="search-input" :disabled="isAddStatus" clearable size="small" :placeholder="$t('memoryBankV2.findText')"
            v-model="filter.source_sent" @clear="handleFilterTable" @keyup.enter.native="handleFilterTable">
          </el-input>
          <el-button :disabled="isAddStatus" class="search-btn" icon="el-icon-search" size="small" type="primary"
            @click="handleFilterTable">
          </el-button>
        </div>
      </div>
      <el-table ref="corpusDetailTable" :data="tableData" border height="calc(100% - 4.28em)"
        header-cell-class-name="header-cell-class-name" cell-class-name="cell-class-name" style="width: 100%"
        :row-class-name="rowClassNameMethod">
        <el-table-column type="index" :index="indexMethod" :label="$t('termBankV2.number')" width="60" align="center">
        </el-table-column>
        <!-- 原文 -->
        <el-table-column prop="sourceSent" :label="$t('termBankV2.originText')" >
          <template slot-scope="{row,$index}">
            <el-input v-if="$index === 0 && isAddStatus && idEditDone" v-model="addRow.sourceSent" resize="none"
              @input="handleTextareaInput(row, 0)" type="textarea"
              :placeholder="$t('memoryBankV2.pleaseInputOriginalText')">
            </el-input>
            <div v-else :class="[editorMode === 'standard' ? 'sourceSent' : 'sourceDiffSent', specialLangClassName('source')]"
              :contenteditable="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus' && !isAddStatus"
              @focus="handleFocus($event,row, 0)" @blur="handleBlur($event, row, 0)" @input="(e) => handleInput(e, row,'source')" @mouseup="(e)=>handleMouseup(e,row,'source')" @keydown="(e)=>handleKeyDown(e,row,'source')"  @paste="(e) => handlePaste(e, row)"  v-html="renderSourceHTML(row)" ></div>
          </template>
        </el-table-column>
        <!-- 译文 -->
        <el-table-column prop="targetSent" :label="$t('termBankV2.translateText')">
          <template slot-scope="{row,$index}">
            <el-input v-if="$index === 0 && isAddStatus && idEditDone" v-model="addRow.targetSent" resize="none"
              @input="handleTextareaInput(row, 1)" type="textarea"
              :placeholder="$t('memoryBankV2.pleaseInputTranslation')">
            </el-input>
            <div v-else :class="[editorMode === 'standard' ? 'targetSent' : 'targetDiffSent', specialLangClassName('target')]"
              :contenteditable="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus' && !isAddStatus"
              @focus="handleFocus($event,row, 1)" @blur="handleBlur($event, row, 1)" @input="(e) => handleInput(e, row,'target')" @mouseup="(e)=>handleMouseup(e,row,'target')" @keydown="(e)=>handleKeyDown(e,row,'target')"  @paste="(e) => handlePaste(e, row)" v-html="renderTargetHTML(row)">
            </div>
          </template>
        </el-table-column>
   >
        <!-- <el-table-column prop="status" :label="$t('projectV2.state')"
                         :width="$i18n.locale==='zh'?'80':'150'" align="center"> -->
        <!-- 1未入库|4已入库|5已打回|6待审核 -->
        <!-- <template slot-scope="{row}">
            <span
                  :class="`status-${row.status}`">{{sentStatusObj[row.status]?sentStatusObj[row.status]:''}}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('common.operation')" width="120"
          v-if="bankStatus == 3 || bankStatus == 4 || fromType === 'corpus'">
          <template slot-scope="{row,$index}">
            <div class="table-icon-warp">
              <template v-if="$index === 0 && isAddStatus">
                <el-tooltip :content="$t('common.save')" effect="dark" placement="top-start">
                  <div class="table-icon-warp_item icon-save" @click="handleAddSentSave(addRow)"></div>
                </el-tooltip>
                <el-tooltip :content="$t('termBankV2.cancel')" effect="dark" placement="top-start">
                  <div class="table-icon-warp_item icon-cancel" @click="handleAddSentCancel(addRow)">
                  </div>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip :disabled="isAddStatus" :content="$t('common.del')" effect="dark" placement="top-start">
                  <div :class="{ 'delete-disabled_icon': isAddStatus }" class="table-icon-warp_item icon-delete"
                    @click="handleDelete(row)"></div>
                </el-tooltip>
                <!-- <div v-else class="table-icon-warp_item icon-prohibit"></div> -->
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer class="corpusDetail-section-footer">
      <Pagination :total="paginationInfo.total" :page.sync="paginationInfo.page" :limit.sync="paginationInfo.rows"
        :pagerCount="paginationInfo.pagerCount" :layout="paginationInfo.layout" :disabled="paginationInfo.disabled"
        @pagination="handlePagination" />
    </footer>
    <!-- 退回原因 -->
    <div class="return-reason-box" v-if="bankStatus == 3 && fromType === 'warehousing'">
      <p class="return-reason-title">拒绝原因</p>
      <div class="return-reason-content">
        <span>{{ bankInfo.refuseDesc ? bankInfo.refuseDesc : '无' }}</span>
      </div>
    </div>
    <!-- 编辑 -->
    <editCorpus :dialogVisible="editorBankVisible" :bankType="routeType" :corpusDetailInfo="corpusDetailInfo"
      @handleClose="editorBankVisible = false" @handleConfirm="handleEditorBankConfirm">
    </editCorpus>
    <!-- 删除库弹窗 -->
    <delete-dialog :dialogVisible="deleteBankVisible" @handleClose="deleteBankVisible = false"
      @handleConfirm="handleDeleteBankConfirm">
    </delete-dialog>
    <!-- 下载库 -->
    <download-corpus-dialog :bankType="routeType" :corpusDetailInfo="corpusDetailInfo"
      :dialogVisible="downloadBankVisible" @handleClose="downloadBankVisible = false">
    </download-corpus-dialog>
    <!-- 删除句子弹窗 -->
    <delete-dialog :dialogVisible="deleteVisible" @handleClose="handleDeleteClose" @handleConfirm="handleDeleteConfirm">
    </delete-dialog>
    <!-- 上传 -->
    <corpus-detail-upload-dialog :corpusDetailInfo="corpusDetailInfo" :bankType="routeType" :accept="accept"
      :dialogVisible="importVisible" @handleClose="handleImportClose" @handleConfirm="handleImportConfirm">
    </corpus-detail-upload-dialog>
    <!-- 入库 -->
    <warehousing-dialog :corpusDetailInfo="corpusDetailInfo" :bankType="routeType" :isWarehousing="isWarehousing" :isFirst="fromType == 'corpus'"
      :dialogVisible="warehousingVisible" @handleClose="handleWarehousingClose" @handleConfirm="handleWarehousingConfirm">
    </warehousing-dialog>
  </section>
</template>
<script>
import DeleteDialog from '../components/deleteDialog.vue';
import CorpusDetailUploadDialog from '../components/corpusDetailUploadDialog.vue';
import DownloadCorpusDialog from '../components/downloadCorpusDialog.vue';
import EditCorpus from '../components/editCorpus.vue';
import WarehousingDialog from '../components/warehousingDialog.vue';
import { removeProperty, loopGetCorpusSentCount } from '@/utils';
import { eventUtil } from "@/components/editor/modules/eventUtil";
import {
  saveSelection,
  restoreSelection,
} from "@/services/common";
import {
  getMemoryDetail,
  getTermDetail,
  queryPage,
  queryPageTermSent,
  addSent,
  addTermSent,
  batchDeleteByIdList,
  batchDeleteByTermSentIdList,
  delMemory,
  updateMemoryBank,
  updateTermBank,
  querySentCount,
  memoryPutInStorage
} from '@/services/memoryBank';
import { delTerm, termQuerySentCount, termPutInStorage } from '@/services/term';
import { cancel, reWarehousing, deleteRecord, corpusInformation } from '@/services/warehousingAudit';
import ExceedTips from '../../../mixins/ExceedTips';
export default {
  name: "corpusDetail",
  mixins: [ExceedTips],
  components: {
    DeleteDialog,
    CorpusDetailUploadDialog,
    DownloadCorpusDialog,
    EditCorpus,
    WarehousingDialog
  },
  data() {
    return {
      // setting.js 判断是入库审核版本
      haveCorpusAuditRecords: haveCorpusAuditRecords,
      // 从记忆库术语库跳转详情 corpus | 从入库审核跳转详情 warehousing
      fromType: '',
      loading: true,
      // 全局setting.js 变量 特殊语种
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      // 路由携带参数
      routeQueryInfo: {},
      // 语料库详情
      corpusDetailInfo: {},
      // 分页器参数
      paginationInfo: {
        total: 0,
        page: 1,
        rows: 10,
        pagerCount: 5,
        layout: 'prev, pager, next,sizes',
        disabled: false
      },
      editorBankVisible: false,
      // 控制删除库弹窗
      deleteBankVisible: false,
      // 控制下载库弹窗
      downloadBankVisible: false,
      // 控制入库弹窗
      warehousingVisible: false,
      // 表格筛选条件
      filter: {
        source_sent: '',
        trans_lib_id: null,
        company_code: localStorage.myCompanyCode,
        platformType: this.$platformType,
      },
      // 表格数据
      tableData: [],
      // 聚焦时获取的句子
      beforeText: '',
      // 控制导入弹窗
      importVisible: false,
      // 是否处于添加单句状态
      isAddStatus: false,
      // 表格处于添加单句状态时，将表格最后一行删除后存储
      lastTableRow: {},
      // 控制删除句子弹窗
      deleteVisible: false,
      // 删除句子的id集合
      deleteIdList: [],
      // 1未入库|4已入库|5已打回|6待审核
      sentStatusObj: {
        1: '',
        3: '',
        4: this.$t('memory.Stockin'),
        5: this.$t('managementV2.returned'),
        6: this.$t('warehousingAudit.toBeReviewed'),
      },
      isWarehousing: false,// true取消入库 false入库
      corpusType: null,
      bankInfo: {}, //审核记录的详细信息
      //编辑模式
      editorMode:'standard', //standard 正常 mark 修改痕迹
      //光标
      startRange: null,
      endRange: null,
      addRow:{
        sourceSent:'',
        targetSent:''
      },
      idEditDone:true,
      viewType: "student", //student 学生 teacher 老师
    }
  },
  computed: {
   /**
     * 渲染html
     */
     renderSourceHTML() {
      return (row) => {
        if (this.editorMode === "standard" && this.viewType === "student") {
          return row.sourceSent;
        } else if (this.editorMode === "mark" && this.viewType === "student") {
          return row.sourceDiffSent;
        } else if ( this.editorMode === "standard" &&this.viewType === "teacher") {
          return row.sourceSent;
        } else if (this.editorMode === "mark" && this.viewType === "teacher") {
          return row.adminSourceDiffSent;
        }
      };
    },
    renderTargetHTML() {
      return (row) => {
        if (this.editorMode === "standard" && this.viewType === "student") {
          return row.targetSent;
        } else if (this.editorMode === "mark" && this.viewType === "student") {
          return row.targetDiffSent;
        } else if ( this.editorMode === "standard" &&this.viewType === "teacher") {
          return row.targetSent;
        } else if (this.editorMode === "mark" && this.viewType === "teacher") {
          return row.adminTargetDiffSent;
        }
      };
    },
    /**
     * @desc 路由匹配
     * @result {String} term|memory|''
     */
    routeType() {
      const reg = /term|memory|Memory|Term/
      let routeName = reg.exec(this.$route.name) ? reg.exec(this.$route.name)[0].toLocaleLowerCase() : ''
      return routeName
    },

    /**
     * @desc 接口方法
     * @property getDetail           获取语料库详情接口方法
     * @property getQueryPage        获取语料库列表接口方法
     * @property addSentence         添加单句接口方法
     * @property deleteSentenceList  列表删除句子接口方法
     * @property deleteCorpusBank    删除语料库接口方法
     * @property updateSentence      更新句子接口方法
     * @property getSentCount        获取句对数接口方法
     * @property corpusPutInStorage  入库接口方法
     */
    ajaxObj() {
      // 记忆库接口方法
      const memoryAjaxObj = {
        getDetail: getMemoryDetail,
        getQueryPage: queryPage,
        addSentence: addSent,
        deleteSentenceList: batchDeleteByIdList,
        deleteCorpusBank: delMemory,
        updateSentence: updateMemoryBank,
        getSentCount: querySentCount,
        corpusPutInStorage: memoryPutInStorage
      }
      // 术语库接口方法
      const termAjaxObj = {
        getDetail: getTermDetail,
        getQueryPage: queryPageTermSent,
        addSentence: addTermSent,
        deleteSentenceList: batchDeleteByTermSentIdList,
        deleteCorpusBank: delTerm,
        updateSentence: updateTermBank,
        getSentCount: termQuerySentCount,
        corpusPutInStorage: termPutInStorage
      }
      const routeTypeObj = {
        memory: memoryAjaxObj,
        term: termAjaxObj
      }
      return routeTypeObj[this.routeType]
    },

    // 导入限制类型
    accept() {
      if (this.routeType === 'memory') {
        return '.zip, .xlsx, .txt, .tmx'
      } else {
        return '.zip, .xlsx, .txt, .tbx'
      }
    },

    // 库id
    bankId() {
      const obj = {
        corpus: this.routeQueryInfo.id,
        warehousing: this.routeQueryInfo.sourceLibId
      }
      return obj[this.fromType]
    },
    //库状态
    bankStatus() {
      return this.bankInfo.status
    },
    //动态样式
    getStatusClass() {
      return {
        'ruku': this.bankStatus == 2 && this.fromType == 'warehousing',
        'shenhezhong': this.bankStatus == 1 && this.fromType == 'warehousing',
        'tuihui': this.bankStatus == 3 && this.fromType == 'warehousing',
        'quxiao': this.bankStatus == 4 && this.fromType == 'warehousing'
      }
    }
  },
  watch: {
    'paginationInfo.page': {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.corpusDetailTable.bodyWrapper.scrollTop = 0
          })
        }
      }
    }
  },
  created() {
    const routeQueryData = JSON.parse(this.$Base64.decode(this.$route.query.key))
    this.routeQueryInfo = routeQueryData.row || {}
    console.log(routeQueryData.type);
    this.fromType = routeQueryData.type
    this.corpusType = routeQueryData.corpusType
    if (Object.keys(this.$route.params).length) {
      const routeParamsData = JSON.parse(this.$Base64.decode(this.$route.params.key))
      this.filter.source_sent = routeParamsData.source_sent
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.fromType == 'warehousing') { //审核记录进来才调用
        this.getBankInfo()
      }
      this.getCorpusDetail()
      this.getTableData()
    })
  },
  methods: {
    //获取库信息
    async getBankInfo() {
      const params = {
        id: this.routeQueryInfo.id,
        corpusType: this.corpusType,
      }
      const { success, result } = await corpusInformation(params)
      if (success) {
        console.log(result);
        this.bankInfo = result
      }
    },
    handleTextareaInput(row, type) {
      if (type) {
        row.targetSent = row.targetSent.replace(/^\s*/g, '');
      } else {
        row.sourceSent = row.sourceSent.replace(/^\s*/g, '');
      }
    },

    // 获取语料库详情
    async getCorpusDetail() {
      console.log(this.routeQueryInfo.targetLibId)
      const params = {
        id: this.routeQueryInfo.targetLibId || this.bankId
      }
      const { success, result } = await this.ajaxObj.getDetail(params)
      if (!success) return
      this.corpusDetailInfo = result
    },

    // 确认编辑库
    handleEditorBankConfirm(data) {
      this.editorBankVisible = false
      data && this.getCorpusDetail()
      if (this.fromType == 'warehousing') { //审核记录进来才调用
        this.getBankInfo()
      }
    },

    // 确认删除库
    async handleDeleteBankConfirm() {
      if (this.fromType == 'corpus') {
        const params = {
          idList: [this.bankId]
        }
        const { success } = await this.ajaxObj.deleteCorpusBank(params)
        if (!success) return
        this.$message.closeAll();
        this.$message.success(this.$t('termBankV2.deleteSuccess'))
        let name = ''
        if (this.haveCorpusAuditRecords) { // 入库审核版本
          name = this.routeType === 'memory' ? 'memoryLib' : 'termLib'
        } else { // 普通版本
          name = this.routeType === 'memory' ? 'memoryBank' : 'termBank'
        }
        let timer = window.setTimeout(() => {
          clearTimeout(timer)
          this.$router.push({ name })
        }, 1500)
      } else if (this.fromType == 'warehousing') {
        const params = {
          id: this.routeQueryInfo.id,
          corpusType: this.corpusType,
        }
        const { success } = await deleteRecord(params)
        if (!success) return
        this.$message.closeAll();
        this.$message.success(this.$t('termBankV2.deleteSuccess'))
        this.$router.go(-1)
      }
    },

    // 列表内容显示
    specialLangClassName(source) {
      const { sourceLang, targetLang } = this.routeQueryInfo
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      } else if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },

    handleWarehousingClose() {
      this.warehousingVisible = false
    },
    // 确认入库
    async handleWarehousingConfirm(data) {
      if (this.isWarehousing) { //取消入库
        const params = {
          corpusType: this.corpusType,
          id: this.routeQueryInfo.id
        }
        const { success, result } = await cancel(params)
        if (!success) return
        this.$message.closeAll()
        this.$message.success(this.$t('homeworkManage.cancelSuccessful'))
        this.warehousingVisible = false
        this.bankInfo.status = result.status
      } else { //入库
        if (this.fromType == 'corpus') { //详情进入
          const { name, id, remark } = data
          const params = {
            name,
            id,
            remark
          }
          const { success } = await this.ajaxObj.corpusPutInStorage(params)
          if (!success) return
        } else if (this.fromType == 'warehousing') { //审核记录 重新入库
          const params = {
            id: this.routeQueryInfo.id,
            corpusType: this.corpusType,
            name: data.name,
            remark: data.remark
          }
          const { success, result } = await reWarehousing(params)
          if (!success) return
          if (this.fromType == 'warehousing') { //审核记录进来才调用
            this.getBankInfo()
          }
          // this.bankInfo.status = result.status
        }
        this.$message.closeAll()
        this.$message.success(this.$t('memory.Warehousingsucceeded'))
        this.handleAddSentCancel()
        this.warehousingVisible = false
        this.getCorpusDetail()
        this.handleFilterTable()

      }
    },
    //入库
    handleRuku() {
      this.isWarehousing = false,// true取消入库 false入库
        this.warehousingVisible = true
    },
    //取消入库
    handleCancelBanke() {
      this.isWarehousing = true,// true取消入库 false入库
        this.warehousingVisible = true
    },
    // 表格序号
    indexMethod(index) {
      let i = index + 1
      return i < 10 ? `0${i}` : i;
    },

    /**
     * @desc 获取表格数据 
     */
    async getTableData() {
      this.filter.trans_lib_id = this.fromType == 'corpus' ? this.bankId : this.routeQueryInfo.targetLibId
      const params = {
        filter: removeProperty({ ...this.filter }),
        page: this.paginationInfo.page,
        rows: this.paginationInfo.rows,
        sort: {
          id: "desc"
        }
      }
      const { list, totalRows, success } = await this.ajaxObj.getQueryPage(params)
      if (!success) return
      this.loading = false
      this.idEditDone=true
      list.forEach(item => {
        item.sourceSent = this.wrapWithEqualSpan(item.sourceSent)
        item.sourceDiffSent = this.wrapWithEqualSpan(item.sourceDiffSent)
        item.targetSent = this.wrapWithEqualSpan(item.targetSent)
        item.targetDiffSent = this.wrapWithEqualSpan(item.targetDiffSent)
      })
      this.tableData = list
      this.paginationInfo.total = totalRows
      if (!list.length && this.paginationInfo.page > 1) {
        this.paginationInfo.page -= 1
        this.getTableData()
      }
    },
    wrapWithEqualSpan(text) {
      // 使用正则表达式检查字符串是否以<span开头，不区分大小写
      const regex = /^<span/i;

      // 如果字符串不以<span开头，则包裹在<span class="equal"></span>中
      if (!regex.test(text)) {
        return `<span class='equal'>${text}</span>`;
      }

      // 否则保持原样
      return text;
    },

    // 表格数据筛选
    handleFilterTable() {
      this.paginationInfo.page = 1
      this.getTableData()
    },
    //光标位置重新处理
    setRangeIndex(dom, index) {
      //光标位置处理
      // 创建新的光标对象
      let range = document.createRange();
      // 光标对象的范围界定为新建的表情节点
      range.selectNodeContents(dom);
      // 光标位置定位在表情节点的最大长度
      range.setStart(dom, index);
      // range.setEnd(leftDom, leftDom.length)
      // 使光标开始和光标结束重叠
      range.collapse(true);
      restoreSelection(range);
    },
    getStartRange() {
      console.log('**--**');
      let tempRange = saveSelection();
      let startIndex = null;
      let endIndex = null;
      let delStr = "";
      let parentNode = null;
      if (tempRange) {
        if (tempRange.endContainer === tempRange.startContainer) {
          parentNode = tempRange.commonAncestorContainer.parentNode.parentNode;
          if (tempRange.commonAncestorContainer.data) {
            delStr = tempRange.commonAncestorContainer.data.slice(
              tempRange.startOffset,
              tempRange.endOffset
            );
          }
        } else {
          parentNode = tempRange.commonAncestorContainer;
        }
      }
      parentNode.childNodes.forEach((item, index) => {
        if (item === tempRange.startContainer.parentNode) {
          startIndex = index;
          if (
            tempRange.endContainer !== tempRange.startContainer &&
            item.className &&
            !item.className.includes("insert")
          ) {
            delStr += item.outerText.slice(tempRange.startOffset);
          }
        }
        if (item === tempRange.endContainer.parentNode) {
          endIndex = index;
          if (
            tempRange.endContainer !== tempRange.startContainer &&
            item.className &&
            !item.className.includes("insert")
          ) {
            delStr += item.outerText.slice(0, tempRange.endOffset);
          }
        }
        if (tempRange.endContainer !== tempRange.startContainer) {
          // console.log(tempRange, item);
          if (
            item.className &&
            !item.className.includes("insert") &&
            startIndex !== null &&
            index > startIndex &&
            endIndex === null
          ) {
            delStr += item.outerText;
          }
          if (
            item.className &&
            !item.className.includes("insert") &&
            startIndex !== null &&
            endIndex !== null &&
            index > startIndex &&
            index < startIndex
          ) {
            delStr += item.outerText;
          }
        }
      });
      this.startRange = {
        startOffset: tempRange.startOffset,
        endOffset: tempRange.endOffset,
        delStr: delStr,
        startContainer: {
          data: tempRange.startContainer.data,
          length: tempRange.startContainer.length,
          index: startIndex,
          className: tempRange.startContainer.parentNode.className,
        },
        endContainer: {
          data: tempRange.endContainer.data,
          length: tempRange.endContainer.length,
          index: endIndex,
          className: tempRange.endContainer.parentNode.className,
        },
        nextData: null,
        nextClass: null,
        isEnd: false,
      };
      if (
        !this.startRange.endContainer.data &&
        !this.startRange.startContainer.data
      ) {
        if (tempRange.commonAncestorContainer.childNodes[tempRange.endOffset]) {
          this.startRange.nextData =
            tempRange.commonAncestorContainer.childNodes[
              tempRange.endOffset
            ].outerText;
          this.startRange.nextClass =
            tempRange.commonAncestorContainer.childNodes[
              tempRange.endOffset
            ].className;
        }
      } else if (
        tempRange.endOffset === tempRange.commonAncestorContainer.length
      ) {
        // console.log(tempRange.commonAncestorContainer.parentNode.nextSibling);
        if (tempRange.commonAncestorContainer.parentNode.nextSibling) {
          this.startRange.nextData =
            tempRange.commonAncestorContainer.parentNode.nextSibling.outerText;
          this.startRange.nextClass =
            tempRange.commonAncestorContainer.parentNode.nextSibling.className;
        }
      }
      if (
        this.startRange.endContainer.index ===
        parentNode.childNodes.length - 1 &&
        this.startRange.endOffset === this.startRange.endContainer.length
      ) {
        this.startRange.isEnd = true;
      }
      // console.log("startRange:", this.startRange);
    },
    handleMouseup(e,row,type){
      this.$nextTick(() => {
        this.getStartRange();
      });
    },
    handleKeyDown(e,row,type){
      if(e.keyCode === 13){
        eventUtil.preventDefault(e);
        //执行失焦事件
        e.target.blur(e,row,type)
      }
      this.getStartRange();
    },
    handlePaste(e, item) {
      // if (this.editorMode !== "mark") {
      //   return;
      // }
      // var e = event || window.event;
      // // 阻止默认粘贴
      // e.preventDefault();
      // // 粘贴事件有一个clipboardData的属性，提供了对剪贴板的访问
      // // clipboardData的getData(fomat) 从剪贴板获取指定格式的数据
      // var text =
      //   (e.originalEvent || e).clipboardData.getData("text/plain") ||
      //   prompt("在这里输入文本");
      // //清除回车
      // text = text.replace(/\[\d+\]|\n|\r/gi, "");
      // // 插入
      // document.execCommand("insertText", false, text);
      // this.pastedData = (e.clipboardData || window.clipboardData).getData(
      //   "text"
      // );
      e.preventDefault();
      var text;
      var clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
          if (window.getSelection) {
            var newNode = document.createElement("span");
            newNode.innerHTML = text;
            window.getSelection().getRangeAt(0).insertNode(newNode);
          } else {
            document.selection.createRange().pasteHTML(text);
          }
        }
      } else {
        text = clp.getData('text/plain') || "";
        if (text !== "") {
          document.execCommand('insertText', false, text);
        }
      }
      // console.log(222222222223333, e, item, this.endRange, this.pastedData);
    },
    handleInput(e, row, type){
      console.log(e.inputType);
      this.endRange = saveSelection();
      let dom = e.target
      switch (e.inputType) {
        case "insertText": //输入
        case "insertCompositionText": //中文输入
          // case 'insertCompositionText': //输入中文时需特殊处理
          if (!this.startRange.delStr) {
            //点击输入
            console.log("点击输入");
            if (
              !this.endRange.commonAncestorContainer.parentNode.className.includes(
                "insert"
              )
            ) {
              let insertInsertDom = document.createElement("span");
              insertInsertDom.innerHTML = e.data;
              insertInsertDom.setAttribute("class", "insert");
              let leftDom = null;
              let rightDom = null;
              if (
                this.startRange.startContainer.className ===
                this.startRange.endContainer.className &&
                this.startRange.startContainer.data === undefined
              ) {
                console.log("当前方是特殊标签时");
                // return
                if (
                  this.endRange.commonAncestorContainer.parentNode === e.target
                ) {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.nextElementSibling
                  );
                  dom.removeChild(this.endRange.commonAncestorContainer);
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else if (
                  this.endRange.commonAncestorContainer.parentNode.nodeName ===
                  "SPAN"
                ) {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.endRange.endContainer.data.slice(
                    this.endRange.endOffset
                  );
                  rightDom.setAttribute(
                    "class",
                    this.endRange.endContainer.parentNode.className
                  );
                  rightDom &&
                    dom.insertBefore(
                      rightDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextElementSibling
                    );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  console.log("重复删除输入");
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
                return;
              } 
              else if (
                this.endRange.endOffset === this.endRange.endContainer.length
              ) {
                //在最后输入添加
                console.log("在最后输入添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                if (this.endRange.commonAncestorContainer.data === e.data) {
                  //重复删除输入
                  console.log(
                    "重复删除输入",
                    leftDom,
                    insertInsertDom,
                    rightDom
                  );
                  if (
                    this.endRange.commonAncestorContainer.parentNode ===
                    e.target
                  ) {
                    console.log("特殊标记前的重复输入");
                  }
                  if(!this.endRange.commonAncestorContainer.parentNode.parentNode.nextElementSibling && !this.endRange.commonAncestorContainer.parentNode.parentNode.previousElementSibling){
                      dom.insertBefore(
                        insertInsertDom,
                        this.endRange.commonAncestorContainer.parentNode.parentNode.parentNode
                          .nextElementSibling
                      );
                      this.endRange.commonAncestorContainer.parentNode.parentNode.parentNode.removeChild(
                        this.endRange.commonAncestorContainer.parentNode.parentNode
                        );
                      this.setRangeIndex(
                        insertInsertDom.childNodes[0],
                        insertInsertDom.childNodes[0].length
                      );
                      return
                  }else{
                    dom.insertBefore(
                      insertInsertDom,
                      this.endRange.commonAncestorContainer.parentNode.parentNode
                        .nextElementSibling
                    );
                    this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                      this.endRange.commonAncestorContainer.parentNode
                      );
                    this.setRangeIndex(
                      insertInsertDom.childNodes[0],
                      insertInsertDom.childNodes[0].length
                    );
                    return
                  }
                }
              }
               else if (this.endRange.endOffset > 1) {
                //在中间添加
                console.log("在中间添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              } else {
                //在开头添加
                console.log("在开头添加");
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              }
              // console.log(leftDom, insertInsertDom, rightDom);
              rightDom &&
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode
                  .nextElementSibling
              );
              leftDom &&
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
                console.log(dom,this.endRange.commonAncestorContainer.parentNode);
              dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            } else {
              //在新增中输入
              console.log('在新增中输入');
            }
          } else {
            //划词输入
            console.log("划词输入",e.data);
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = e.data;
            insertInsertDom.setAttribute("class", "insert");

            let insertDelDom = document.createElement("span");
            insertDelDom.innerHTML = this.startRange.delStr;
            insertDelDom.setAttribute("class", "del");
            console.log(insertDelDom);
            if (
              !this.endRange.commonAncestorContainer.parentNode.className.includes(
                "insert"
              )
            ) {
              let insertInsertDom = document.createElement("span");
              insertInsertDom.innerHTML = e.data;
              insertInsertDom.setAttribute("class", "insert");
              let leftDom = null;
              let rightDom = null;
              if (
                this.startRange.startContainer.className ===
                this.startRange.endContainer.className &&
                this.startRange.startContainer.data === undefined
              ) {
                console.log("当前方是特殊标签时");
                // return
                if (
                  this.endRange.commonAncestorContainer.parentNode === e.target
                ) {
                  dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.nextElementSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.nextElementSibling
                  );
                  dom.removeChild(this.endRange.commonAncestorContainer);
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else if (
                  this.endRange.commonAncestorContainer.parentNode.nodeName ===
                  "SPAN"
                ) {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.endRange.endContainer.data.slice(
                    this.endRange.endOffset
                  );
                  rightDom.setAttribute(
                    "class",
                    this.endRange.endContainer.parentNode.className
                  );
                  rightDom &&
                    dom.insertBefore(
                      rightDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextElementSibling
                    );
                  dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  console.log("重复删除输入");
                  dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextElementSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
                return;
              } 
              else if (
                this.endRange.endOffset === this.endRange.endContainer.length
              ) {
                //在最后输入添加
                console.log("在最后输入添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                if (this.endRange.commonAncestorContainer.data === e.data) {
                  //重复删除输入
                  console.log(
                    "重复删除输入",
                    leftDom,
                    insertInsertDom,
                    rightDom
                  );
              
                  if (
                    this.endRange.commonAncestorContainer.parentNode ===
                    e.target
                  ) {
                    console.log("特殊标记前的重复输入");
                  }
                  if(!this.endRange.commonAncestorContainer.parentNode.parentNode.nextElementSibling && !this.endRange.commonAncestorContainer.parentNode.parentNode.previousElementSibling){
                    console.log('@@1', this.endRange.commonAncestorContainer.parentNode.nextElementSibling);
                      dom.insertBefore(
                      insertDelDom,
                      this.endRange.commonAncestorContainer.parentNode.nextElementSibling
                      );
                      dom.insertBefore(
                        insertInsertDom,
                        this.endRange.commonAncestorContainer.parentNode.nextElementSibling
                      );
                      this.endRange.commonAncestorContainer.parentNode.removeChild(
                        this.endRange.commonAncestorContainer
                        );
                      this.setRangeIndex(
                        insertInsertDom.childNodes[0],
                        insertInsertDom.childNodes[0].length
                      );
                      return
                  }else{
                    console.log('@@2');
                    dom.insertBefore(
                      insertDelDom,
                      this.endRange.commonAncestorContainer.parentNode.parentNode.parentNode
                          .nextElementSibling
                      );
                    dom.insertBefore(
                      insertInsertDom,
                      this.endRange.commonAncestorContainer.parentNode.parentNode
                        .nextElementSibling
                    );
                    this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                      this.endRange.commonAncestorContainer.parentNode
                      );
                    this.setRangeIndex(
                      insertInsertDom.childNodes[0],
                      insertInsertDom.childNodes[0].length
                    );
                    return
                  }
                }
              }
               else if (this.endRange.endOffset > 1) {
                //在中间添加
                console.log("在中间添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              } else {
                //在开头添加
                console.log("在开头添加");
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              }
              // console.log(leftDom, insertInsertDom, rightDom);
              rightDom && dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                  );
              rightDom &&
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
              dom.insertBefore(
                insertDelDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
              );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode
                  .nextElementSibling
              );
              leftDom && dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                  );
              leftDom &&
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
                console.log(dom,this.endRange.commonAncestorContainer.parentNode);
              dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            } else {
              //在新增中输入
              console.log('在新增中输入');
            }
            
          }
          break;
        case "insertFromPaste": //粘贴的
          console.log("粘贴输入的", this.pastedData);
          if (!this.startRange.delStr) {
            //点击输入
            // console.log("点击输入");
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = this.pastedData;
            insertInsertDom.setAttribute("class", "insert");
            let leftDom = null;
            let rightDom = null;
            if (
              this.startRange.startContainer.className ===
              this.startRange.endContainer.className &&
              this.startRange.startContainer.data === undefined
            ) {
              console.log("当前方是特殊标签时");
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.nextSibling
                );
                dom.removeChild(this.endRange.commonAncestorContainer);
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else if (
                this.endRange.commonAncestorContainer.parentNode.nodeName ===
                "SPAN"
              ) {
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else {
                console.log("重复删除输入");
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                    .nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
              return;
            } else if (
              this.startRange.endOffset > 0 &&
              this.startRange.endOffset < this.startRange.endContainer.length
            ) {
              //在中间添加
              console.log("在中间添加", this.endRange.endContainer.parentNode);
              if (
                this.endRange.commonAncestorContainer.parentNode.parentNode ===
                e.target
              ) {
                leftDom = document.createElement("span");
                leftDom.innerHTML =
                  this.endRange.endContainer.parentNode.outerText.slice(
                    0,
                    this.startRange.endOffset
                  );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.endContainer.parentNode.outerText
                    .slice(this.startRange.endOffset + this.pastedData.length)
                    .trim();
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                // console.log(
                //   leftDom,
                //   insertInsertDom,
                //   rightDom,
                //   this.endRange.commonAncestorContainer.parentNode,
                //   this.endRange.commonAncestorContainer.parentNode.nextSibling
                // );
                rightDom &&
                  rightDom.innerHTML.length > 0 &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else {
                leftDom = document.createElement("span");
                leftDom.innerHTML =
                  this.endRange.endContainer.parentNode.parentNode.outerText.slice(
                    0,
                    this.startRange.endOffset
                  );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.endContainer.parentNode.parentNode.outerText
                    .slice(this.startRange.endOffset + this.pastedData.length)
                    .trim();
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.parentNode.className
                );
                // console.log(
                //   leftDom,
                //   insertInsertDom,
                //   rightDom,
                //   this.endRange.commonAncestorContainer.parentNode.parentNode,
                //   this.endRange.commonAncestorContainer.parentNode.parentNode
                //     .nextSibling
                // );
                rightDom &&
                  rightDom.innerHTML.length > 0 &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                    .nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
              return;
            } else if (this.startRange.isEnd) {
              //在最后输入添加
              console.log("在最后输入添加");
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                // console.log(111);
                let parentDom =
                  this.endRange.commonAncestorContainer.parentNode;
                let clearDomList = [];
                parentDom.childNodes.forEach((element, index) => {
                  if (index > this.startRange.endContainer.index) {
                    clearDomList.push(element);
                  }
                });
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                // console.log(clearDomList);
                clearDomList.forEach((element) => {
                  dom.removeChild(element);
                });
              } else {
                // console.log(222);
                if (
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "equal"
                  ) ||
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "del"
                  ) ||
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "insert"
                  )
                ) {
                  console.log("2-1");
                  leftDom = document.createElement("span");
                  leftDom.innerHTML =
                    this.endRange.commonAncestorContainer.data.slice(
                      0,
                      this.endRange.endOffset - this.pastedData.length
                    );
                  leftDom.setAttribute(
                    "class",
                    this.endRange.commonAncestorContainer.parentNode.className
                  );
                  // console.log(leftDom, insertInsertDom);
                  return;
                  leftDom &&
                    dom.insertBefore(
                      leftDom,
                      this.endRange.commonAncestorContainer.parentNode
                    );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  console.log("2-2");
                  let parentDom =
                    this.endRange.commonAncestorContainer.parentNode.parentNode;
                  let clearDomList = [];
                  parentDom.childNodes.forEach((element, index) => {
                    if (index > this.startRange.endContainer.index) {
                      clearDomList.push(element);
                    }
                  });
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                  // console.log(clearDomList);
                  clearDomList.forEach((element) => {
                    dom.removeChild(element);
                  });
                }
              }
              return;
            } else if (
              this.startRange.startOffset === 0 &&
              this.startRange.endOffset === 0 &&
              this.startRange.startContainer.index === 0 &&
              this.startRange.endContainer.index === 0
            ) {
              //在开头添加
              console.log(
                "在开头添加",
                this.endRange.commonAncestorContainer.parentNode.parentNode
              );

              let clearDomList = [];
              if (
                this.endRange.commonAncestorContainer.parentNode.parentNode ===
                e.target
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.commonAncestorContainer.data.slice(
                    this.endRange.endOffset
                  );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
              } else {
                let parentDom =
                  this.endRange.commonAncestorContainer.parentNode.parentNode;
                let pass = false;
                parentDom.childNodes.forEach((element, index) => {
                  if (!pass) {
                    clearDomList.push(element);
                  }
                  if (element === this.endRange.endContainer.parentNode) {
                    pass = true;
                  }
                });
                // console.log(
                //   clearDomList,
                //   this.endRange.commonAncestorContainer.parentNode,
                //   insertInsertDom
                // );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                clearDomList.forEach((element) => {
                  this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                    element
                  );
                });
              }
              return;
            } else if (
              this.startRange.endOffset === this.startRange.endContainer.length
            ) {
              //在元素后方复制
              console.log("在元素后方复制");
              if (this.startRange.nextData) {
                console.log("在元素后方复制1");
                if (
                  this.endRange.commonAncestorContainer.parentNode
                    .parentNode === e.target
                ) {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.startRange.nextData;
                  rightDom.setAttribute("class", this.startRange.nextClass);
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.startRange.nextData;
                  rightDom.setAttribute("class", this.startRange.nextClass);
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
              } else {
                console.log("在元素后方复制2");
                if (
                  this.endRange.commonAncestorContainer.parentNode === e.target
                ) {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.nextSibling
                  );
                  dom.removeChild(this.endRange.commonAncestorContainer); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
              }
              return;
            }
            // console.log(leftDom, insertInsertDom, rightDom);
            // console.log(
            //   this.endRange.commonAncestorContainer.parentNode.parentNode
            // );

            // rightDom && dom.insertBefore(rightDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // dom.insertBefore(insertInsertDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // leftDom && dom.insertBefore(leftDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // dom.removeChild(this.endRange.commonAncestorContainer.parentNode.parentNode) //删除项
            // this.setRangeIndex(insertInsertDom.childNodes[0], insertInsertDom.childNodes[0].length)
          } else {
            //划词输入
            console.log("划词输入");
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = e.data;
            insertInsertDom.setAttribute("class", "insert");
            let insertDelDom = document.createElement("span");
            insertDelDom.innerHTML = this.startRange.delStr;
            insertDelDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.parentNode.nextSibling
              );
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.parentNode
              );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode
              );
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删并添加输入文字");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
            }
          }
          break;

        case "deleteContentBackward": //BackSpace删除
          if (!this.startRange.delStr) {
            console.log('不是划词删除');
            //不是划词删除
            if (this.startRange.startContainer.className.includes("del")) {
              //del
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.startContainer.data;
              insertDom.setAttribute("class", "del");
              if (this.startRange.startOffset === 1) {
                if (this.startRange.startContainer.length > 1) {
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                      .nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.previousElementSibling.childNodes[0],
                    insertDom.previousElementSibling.childNodes[0].length
                  );
                } else {
                  if (
                    this.endRange.startOffset === 0 &&
                    !this.endRange.commonAncestorContainer.parentNode
                      .previousElementSibling
                  ) {
                    //当光标前一个元素都没有时
                    dom.insertBefore(
                      insertDom,
                      this.endRange.commonAncestorContainer.parentNode
                    );
                    this.setRangeIndex(insertDom.childNodes[0], 0);
                  } else {
                    dom.insertBefore(
                      insertDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                  }
                }
              } else {
                // console.log(2222);
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  this.startRange.startOffset - 1
                );
              }
            }
            if (
              (this.startRange.startContainer.className === "equal" &&
                this.startRange.endContainer.className === "equal") ||
              (this.startRange.startContainer.className === "text" &&
                this.startRange.endContainer.className === "text")
            ) {
              //equal 兼容 text
              console.log('$@$');
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.endContainer.data.slice(
                this.startRange.startOffset - 1,
                this.startRange.endOffset
              );
              insertDom.setAttribute("class", "del");
              // console.log(
              //   insertDom,
              //   this.endRange.commonAncestorContainer.parentNode
              // );
              //将删除的内容以下划线的形式填充到当前位置
              // console.log(this.endRange);
              if (
                this.endRange.startOffset ===
                this.endRange.startContainer.length
              ) {
                //当光标所处位置的前一个元素为一个单元整体时
                console.log("当光标所处位置的前一个元素为一个单元整体时",insertDom,dom,'下一个元素', this.endRange.commonAncestorContainer.parentNode.nextSibling);
                this.$nextTick(() => {
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.previousElementSibling.childNodes[0],
                    insertDom.previousElementSibling.childNodes[0].length
                  );
                })
              } else if (
                this.endRange.startOffset === 0 &&
                !this.endRange.commonAncestorContainer.parentNode
                  .previousElementSibling
              ) {
                //当光标前一个元素都没有时
                console.log("当光标前一个元素都没有时");
                console.log(
                  this.endRange.commonAncestorContainer.parentNode
                    .previousElementSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(insertDom.childNodes[0], 0);
              } else if (
                this.endRange.startContainer === this.endRange.endContainer &&
                this.endRange.endContainer === e.target
              ) {
                //当前方是特殊标签时
                console.log("当前方是特殊标签时");
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.childNodes[
                  this.endRange.endOffset
                  ]
                );
              } else {
                console.log("当前后有元素需要分割时");
                let leftDom = null;
                let rightDom = null;
                if (this.startRange.startOffset > 1) {
                  leftDom = document.createElement("span");
                  leftDom.innerHTML = this.endRange.startContainer.data.slice(
                    0,
                    this.startRange.startOffset - 1
                  );
                  leftDom.setAttribute("class", "equal");
                }
                // console.log(
                //   this.endRange.endContainer,
                //   this.endRange.endOffset
                // );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                if (this.endRange.endOffset > 0) {
                  rightDom.setAttribute("class", "equal");
                }
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                if (leftDom) {
                  this.setRangeIndex(
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0],
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0].length
                  );
                } else {
                  this.setRangeIndex(
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0],
                    0
                  );
                }
              }
            }
          } else {
            //划词删除
            console.log("划词删除", this.startRange, this.endRange);
            let insertDom = document.createElement("span");
            insertDom.innerHTML = this.startRange.delStr;
            insertDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              if (
                !(
                  this.startRange.startContainer.className.includes("insert") &&
                  this.startRange.endContainer.className.includes("insert") &&
                  this.startRange.startContainer.data ===
                  this.startRange.endContainer.data
                )
              ) {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              if (this.endRange.commonAncestorContainer === e.target) {
                dom.innerHTML = "";
                dom.appendChild(insertDom);
              } else {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  leftDom.childNodes[0],
                  leftDom.childNodes[0].length
                );
              }
            }
          }
          break;
        case "deleteContentForward": //del删除
          if (!this.startRange.delStr) {
            //不是划词删除
            if (this.startRange.startContainer.className.includes("del")) {
              //del
              console.log("del");
              if (this.startRange.nextClass) {
                if (
                  this.startRange.nextClass.includes("equal") ||
                  this.startRange.nextClass.includes("del")
                ) {
                  // console.log(111111);
                  let insertDom = document.createElement("span");
                  insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
                  insertDom.setAttribute("class", "del");
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                }
              } else {
                let insertDom = document.createElement("span");
                insertDom.innerHTML = this.startRange.endContainer.data.slice(
                  this.startRange.startOffset,
                  this.startRange.endOffset + 1
                );
                insertDom.setAttribute("class", "del");
                // console.log(insertDom);
                let leftDom = null;
                let rightDom = null;
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.startRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute("class", "del");
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute("class", "del");
                // console.log(leftDom, insertDom, rightDom);
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            } else if (
              (this.startRange.startContainer.className === "equal" &&
                this.startRange.endContainer.className === "equal") ||
              (this.startRange.startContainer.className === "text" &&
                this.startRange.endContainer.className === "text")
            ) {
              //equal 兼容 text
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.endContainer.data.slice(
                this.startRange.startOffset,
                this.startRange.endOffset + 1
              );
              insertDom.setAttribute("class", "del");
              // console.log(
              //   insertDom,
              //   this.endRange.commonAncestorContainer.parentNode
              // );
              //将删除的内容以下划线的形式填充到当前位置
              // console.log(this.endRange);
              if (
                this.endRange.startOffset ===
                this.endRange.startContainer.length
              ) {
                //当光标所处位置的前一个元素为一个单元整体时
                console.log("当光标所处位置的前一个元素为一个单元整体时");
                if (!this.startRange.nextData) {
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                } else if (!this.startRange.nextClass.includes("insert")) {
                  let insertDom = document.createElement("span");
                  insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
                  insertDom.setAttribute("class", "del");
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                }
              } else if (
                this.endRange.startOffset === 0 &&
                !this.endRange.commonAncestorContainer.parentNode
                  .previousElementSibling
              ) {
                //当光标前一个元素都没有时
                console.log("当光标前一个元素都没有时");
                // console.log(
                //   this.endRange.commonAncestorContainer.parentNode
                //     .previousElementSibling
                // );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              } else {
                console.log("当前后有元素需要分割时");
                let leftDom = null;
                let rightDom = null;
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.startRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute("class", "equal");
                // console.log(
                //   this.endRange.endContainer,
                //   this.endRange.endOffset
                // );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                if (this.endRange.endOffset > 0) {
                  rightDom.setAttribute("class", "equal");
                }
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
              insertDom.setAttribute("class", "del");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
              this.setRangeIndex(
                insertDom.childNodes[0],
                insertDom.childNodes[0].length
              );
            } else if (
              this.startRange.nextData &&
              this.startRange.nextData.length > 0
            ) {
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
              insertDom.setAttribute("class", "del");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.parentNode.nextSibling
              );
              this.setRangeIndex(
                insertDom.childNodes[0],
                insertDom.childNodes[0].length
              );
            }
          } else {
            //划词删除
            console.log("划词删除", this.startRange, this.endRange);
            let insertDom = document.createElement("span");
            insertDom.innerHTML = this.startRange.delStr;
            insertDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              if (
                !(
                  this.startRange.startContainer.className.includes("insert") &&
                  this.startRange.endContainer.className.includes("insert") &&
                  this.startRange.startContainer.data ===
                  this.startRange.endContainer.data
                )
              ) {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              if (this.endRange.commonAncestorContainer === e.target) {
                dom.innerHTML = "";
                dom.appendChild(insertDom);
              } else {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            }
          }
          break;

        case "historyUndo": //撤回
          console.log("撤回");
          // dom.removeChild(insertDom)
          break;
        default:
          break;
      }
    },
     //中文输入事件
    handleCompositionend(e) {
      console.log("handleCompositionend", e);
      this.endRange = saveSelection();
      //获取要操作的dom元素
      let dom = e.target;

      if (!this.startRange.delStr && e.data.length > 0) {
        //点击输入
        console.log("点击输入");
        if (
          !this.endRange.commonAncestorContainer.parentNode.className.includes(
            "insert"
          )
        ) {
          let insertInsertDom = document.createElement("span");
          insertInsertDom.innerHTML = e.data;
          insertInsertDom.setAttribute("class", "insert");
          let leftDom = null;
          let rightDom = null;
          if (
            this.startRange.startContainer.className ===
            this.startRange.endContainer.className &&
            this.startRange.startContainer.data === undefined
          ) {
            console.log("当前方是特殊标签时");
            if (this.endRange.commonAncestorContainer.parentNode === e.target) {
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.nextElementSibling
              );
              dom.removeChild(this.endRange.commonAncestorContainer);
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            } else {
              console.log("重复删除输入");
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode.parentNode
                  .nextElementSibling
              );
              dom.removeChild(
                this.endRange.commonAncestorContainer.parentNode.parentNode
              );
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            }
            return;
          } else if (
            this.endRange.endOffset === this.endRange.endContainer.length
          ) {
            //在最后输入添加
            console.log("在最后输入添加");
            leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.endContainer.data.slice(
              0,
              this.endRange.endOffset - e.data.length
            );
            leftDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            if (this.endRange.commonAncestorContainer.data === e.data) {
              //重复删除输入
              console.log("重复删除输入", leftDom, insertInsertDom, rightDom);
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                console.log("特殊标记前的重复输入");
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.childNodes[0]
                );
                console.log(this.endRange.commonAncestorContainer);
                this.endRange.commonAncestorContainer.parentNode.removeChild(
                  this.endRange.commonAncestorContainer
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                return;
              }
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode.parentNode
                  .nextElementSibling
              );
              this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                this.endRange.commonAncestorContainer.parentNode
              );
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
              return;
            }
          } else if (this.endRange.endOffset > 1) {
            //在中间添加
            console.log("在中间添加");
            leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.endContainer.data.slice(
              0,
              this.endRange.endOffset - e.data.length
            );
            leftDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
          } else {
            //在开头添加
            console.log("在开头添加");
            rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
          }
          // console.log(leftDom, insertInsertDom, rightDom);
          rightDom &&
            dom.insertBefore(
              rightDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.parentNode.nextElementSibling
          );
          leftDom &&
            dom.insertBefore(
              leftDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
          this.setRangeIndex(
            insertInsertDom.childNodes[0],
            insertInsertDom.childNodes[0].length
          );
        } else {
          //在新增中输入
        }
      } else {
        //划词输入
        console.log("划词输入");
        let insertInsertDom = document.createElement("span");
        insertInsertDom.innerHTML = e.data;
        insertInsertDom.setAttribute("class", "insert");
        let insertDelDom = document.createElement("span");
        insertDelDom.innerHTML = this.startRange.delStr;
        insertDelDom.setAttribute("class", "del");
        if (this.endRange.endContainer.length === this.endRange.endOffset) {
          console.log("当光标所处位置的前一个元素为一个单元整体时");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.parentNode.nextElementSibling
          );
          if (!this.startRange.startContainer.className.includes("insert")) {
            dom.insertBefore(
              insertInsertDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          }
        } else if (
          this.endRange.startContainer === this.endRange.endContainer &&
          this.endRange.endOffset === 0
        ) {
          console.log("最前方已没有数据");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.parentNode
          );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.parentNode
          );
        } else if (
          this.endRange.startContainer === this.endRange.endContainer &&
          this.endRange.endContainer === e.target
        ) {
          //当前方是特殊标签时
          console.log("当前方是特殊标签时");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.childNodes[
            this.endRange.endOffset
            ]
          );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.childNodes[
            this.endRange.endOffset
            ]
          );
        } else {
          //从中间划词删
          console.log("从中间划词删并添加输入文字");
          if (!this.startRange.startContainer.className.includes("insert")) {
            let leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.startContainer.data.slice(
              0,
              this.startRange.startOffset
            );
            leftDom.setAttribute(
              "class",
              this.endRange.startContainer.parentNode.className
            );
            let rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            dom.insertBefore(
              rightDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              insertDelDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              insertInsertDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              leftDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
            this.setRangeIndex(
              insertInsertDom.childNodes[0],
              insertInsertDom.childNodes[0].length
            );
          }
        }
      }
    },

    handleFocus(e,row,type) {
      this.idEditDone=false
      // if(type==1 && this.editorMode == 'standard'){
      if(type == 1){
        e.target.innerHTML = row.targetDiffSent;
      }else if(type == 0){
        e.target.innerHTML = row.sourceDiffSent;
      }
      this.beforeText = e.target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "")
    },
    changeInnerHTML(e,row,type){
      if (type == 1 && this.editorMode == "standard") {
        e.target.innerHTML = row.targetSent;
      } else if (type == 1 && this.editorMode == "mark" && this.viewType == 'student') {
        e.target.innerHTML = row.targetDiffSent;
      } else if (type == 1 && this.editorMode == "mark" && this.viewType == 'teacher') {
        e.target.innerHTML = row.adminTargetDiffSent;
      } else if (type == 0 && this.editorMode == "standard") {
        e.target.innerHTML = row.sourceSent;
      }else if (type == 0 && this.editorMode == "mark" && this.viewType == 'student') {
        e.target.innerHTML = row.sourceDiffSent;
      } else if (type == 0 && this.editorMode == "mark" && this.viewType == 'teacher') {
        e.target.innerHTML = row.adminSourceDiffSent;
      } 
    },
    async handleBlur(e, row, type) {
      const { target } = e;
      const innerHTML = e.target.innerHTML;
      console.log(innerHTML == row.sourceDiffSent ,type);
      if(type == 0){
        if(innerHTML == row.sourceDiffSent){
          this.idEditDone=true
          this.changeInnerHTML(e,row,type)
          return
        } 
      }else{
        if(innerHTML == row.targetDiffSent) {
          this.idEditDone=true
          this.changeInnerHTML(e,row,type)
          return
        }
      }
      // 使用正则表达式匹配所有<span class="equal">、<span class="insert">元素内的内容
      const regex = /<span class="(?:equal|insert)">([^<]*)<\/span>/g;

      let matches = [];
      let match;
      // 循环匹配并提取内容到数组
      while ((match = regex.exec(innerHTML)) !== null) {
        matches.push(match[1]);
      }
      // 将匹配到的内容按原来的顺序拼接成一个字符串
      let updateText = matches.join('');

      updateText = updateText.trim();

      console.log(updateText);
      
      // const updateText = innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (updateText === '') {
        this.$message.closeAll()
        this.$message.error(this.$t('memoryBankV2.updateContent'))
        // 光标定位选中
        this.keepLastIndex(target)
        this.changeInnerHTML(e,row,type)
        // target.innerText = this.beforeText
        return
      }
      if (updateText === this.beforeText) {
        this.changeInnerHTML(e,row,type)
        return;
      }
      const params = {
        id: row.id,
        transLibId: this.corpusDetailInfo.id
      }
      if(type){
        params.targetSent = updateText
        params.targetDiffSent = innerHTML
      }else{
        params.sourceSent = updateText
        params.sourceDiffSent = innerHTML
      }
      console.log(params);
      // return
      const { success } = await this.ajaxObj.updateSentence(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success(this.$t("memoryBankV2.editSuccess"))
        this.getTableData()
        this.$nextTick(() => {
            if (type == 1 && this.editorMode == "mark" && this.viewType == 'teacher') {
              e.target.innerHTML = row.adminTargetDiffSent;
            } 
            else if (type == 0 && this.editorMode == "mark" && this.viewType == 'teacher') {
              e.target.innerHTML = row.adminSourceDiffSent;
            } 
          })
      } else {
        e.target.innerText = this.beforeText;
        this.idEditDone=true
      }
    },
    // 光标定位方法
    keepLastIndex(dom) {
      if (window.getSelection) {
        dom.focus();
        const range = window.getSelection();
        range.selectAllChildren(dom);
        range.collapseToEnd();
      } else if (document.selection) {
        const range = document.selection.createRange();
        range.moveToElementText(dom);
        range.collapse(false);
        range.select();
      }
    },

    /**
     * @desc // 分页器数量或页面改变方法
     * @param {Object} data {page,limit}
     */
    handlePagination({ page, limit }) {
      this.getTableData()
    },

    // 点击导入
    handleImport() {
      this.importVisible = true
    },
    // 取消导入
    handleImportClose() {
      this.importVisible = false
    },
    // 确认导入
    async handleImportConfirm() {
      this.importVisible = false
      this.loading = true
      const res = await loopGetCorpusSentCount(this.ajaxObj.getSentCount, { idList: [this.corpusDetailInfo.id] })
      if (res[0].status === 1) {
        this.paginationInfo.page = 1
        let timer = window.setTimeout(() => {
          clearTimeout(timer)
          this.getTableData()
          this.getCorpusDetail()
          if (this.fromType == 'warehousing') { //审核记录进来才调用
            this.getBankInfo()
          }
        }, 1000)
      }
    },

    // 表格添加单句样式
    rowClassNameMethod({ row, rowIndex }) {
      if (rowIndex === 0 && this.isAddStatus) {
        return 'add-sent-first-row'
      }
      // if (row.status === 6) {
      //   return 'prohibit-row'
      // }
    },
    // 点击添加单句
    handleAddSent() {
      this.idEditDone = true
      this.isAddStatus = true
      this.paginationInfo.disabled = true
      this.spliceTableList()
    },

    /**
     * @desc 添加单句时截取表格列表 第一行设置为空行
     */
    spliceTableList() {
      if (this.tableData.length === this.paginationInfo.rows) {
        this.lastTableRow = this.tableData.splice(this.tableData.length - 1, 1)[0]
      }
      this.tableData.unshift({
        sourceSent: '',
        targetSent: ''
      })
    },

    // 取消添加单句
    handleAddSentCancel() {
      if (this.isAddStatus) {
        this.isAddStatus = false
        this.paginationInfo.disabled = false
        this.addRow={
          sourceSent:'',
          targetSent:''
        }
        this.tableData.shift()
        if (Object.keys(this.lastTableRow).length) {
          this.tableData.push(this.lastTableRow)
          this.lastTableRow = {}
        }
      }
    },
    // 确认添加单句
    async handleAddSentSave({ sourceSent, targetSent }) {
      if (!sourceSent || !targetSent) {
        this.$message.closeAll()
        this.$message.warning(this.$t('warehousingAudit.cannotEmpty'))
        return
      }
      const params = {
        sourceSent,
        targetSent,
        transLibId: this.fromType == 'corpus' ? this.bankId : this.bankInfo.targetLibId
      }
      const { success } = await this.ajaxObj.addSentence(params)
      if (!success) return
      this.$message.closeAll()
      this.$message.success(this.$t('common.added'))
      this.isAddStatus = false
      this.paginationInfo.disabled = false
      this.addRow={
        sourceSent:'',
        targetSent:''
      }
      this.lastTableRow = {}
      this.paginationInfo.page = 1
      this.getTableData()
      this.getCorpusDetail()
      if (this.fromType == 'warehousing') { //审核记录进来才调用
        this.getBankInfo()
      }
    },

    // 点击删除按钮
    handleDelete({ id }) {
      if (this.isAddStatus) return
      this.deleteVisible = true
      this.deleteIdList.push(id)
    },
    // 表格取消删除
    handleDeleteClose() {
      this.deleteVisible = false
      this.deleteIdList = []
    },
    // 表格确认删除
    async handleDeleteConfirm() {
      const params = {
        idList: this.deleteIdList
      }
      const { success } = await this.ajaxObj.deleteSentenceList(params)
      if (!success) return
      this.deleteIdList = []
      this.$message.closeAll();
      this.$message.success(this.$t('termBankV2.deleteSuccess'))
      this.getTableData()
      this.getCorpusDetail()
      if (this.fromType == 'warehousing') { //审核记录进来才调用
        this.getBankInfo()
      }
      this.deleteVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "./style/index.less";
</style>

<style lang="less" scoped>
.sourceSent {
  word-break: break-word;
}
.targetSent{
  word-break: break-word;
}
.sourceDiffSent {
  word-break: break-word;
}
.targetDiffSent{
  word-break: break-word;
}
</style>